import script from "./Auditshops.vue?vue&type=script&setup=true&lang=js"
export * from "./Auditshops.vue?vue&type=script&setup=true&lang=js"

import "./Auditshops.vue?vue&type=style&index=0&id=de785990&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-de785990"]])

export default __exports__